import * as React from 'react';
import { createMemoryRouter, RouterProvider } from 'react-router-dom';

import Root from './components/Root';
import MainMenu from './components/MainMenu';
import ComputerMenu from './components/ComputerMenu';
import OnlineMenu from './components/OnlineMenu';
import OnlineWaitingRoom from './components/OnlineWaitingRoom';
import About from './components/About';
import Achievements from './components/Achievements';
import AvatarPicker from './components/Avatar/AvatarPicker';
import Game from './components/Game';
import Statistics from './components/Statistics';
import HowToPlay from './components/HowToPlay';
import Settings from './components/Settings';
import Loading from './components/Loading';
import MoreGames from './components/MoreGames';
import Test from './components/Test';
import Store from './components/Store';
import Profile from './components/Profile';
import { AppContextProvider } from './AppContext';

const router = createMemoryRouter([
	{
		path: '/',
		element: <Root />,
		children: [
			{
				index: true,
				path: '/',
				element: <MainMenu />,
			},
			{
				path: '/MainMenu',
				element: <MainMenu />,
			},
			{
				path: 'ComputerMenu',
				element: <ComputerMenu />,
			},
			{
				path: 'About',
				element: <About />,
			},
			{
				path: 'Achievements',
				element: <Achievements />,
			},
			{
				path: 'Game/:mode/:level',
				element: <Game />,
			},
			{
				path: 'Statistics',
				element: <Statistics />,
			},
			{
				path: 'HowToPlay',
				element: <HowToPlay />,
			},
			{
				path: 'Settings',
				element: <Settings />,
			},
			{
				path: 'Loading',
				element: <Loading />,
			},
			{
				path: 'MoreGames',
				element: <MoreGames />,
			},
			{
				path: 'Test',
				element: <Test />,
			},
			{
				path: 'Store',
				element: <Store />,
			},
			{
				path: 'Profile',
				element: <Profile />,
			},
			{
				path: 'Avatar',
				element: <AvatarPicker />,
			},
			{
				path: 'Online',
				element: <OnlineMenu />,
			},
			{
				path: 'Online/:mode',
				element: <OnlineWaitingRoom />,
			},
			{
				path: '*',
				element: <MainMenu />,
			},
		],
	},
]);

const App = () => {

	if (import.meta.hot) {
		import.meta.hot.dispose(() => router.dispose());
	}

	return (
		<AppContextProvider router={router}>
			<RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
		</AppContextProvider>
	);
};

export default App;
